/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * BETWEEN operator looks for values: left <= value <= right.
 */
export interface BetweenVersion {
    /** Left value to compare against. */
    left: number;
    /** Right value to compare against. */
    right: number;
}
